import { apiFetch } from '../fetchApi'

export const fetchSubmissionReport = async (BeURL, showAlert, filters, setReportData, setLoading, key) => {
    try {
        setLoading(prev =>( {...prev,
            [key]: true
        }))
        const res = await apiFetch(`${BeURL}/submissionOverall-report`, {
            method: "POST",
            body: JSON.stringify(filters)
        })
        const data = await res.json()

        if (data.success) {
            // let x = [], y = []
            console.log("Works3")
            setReportData(prev => {
                let tempReportData = { ...prev }
                const submissionData = data.eachSubmissions || []
                // data: [
                //     {
                //         "x-axis": [],
                //         "y-axis": []
                //     }
                // ],
                if (submissionData?.length) {

                    const x = submissionData.map(item => item.applicantName || "Unknown");
                    const y = submissionData.map(item => item.count || 0);
                    const formattedData = [{
                        "x-axis": x,
                        "y-axis": y

                    }]
                    tempReportData["submissions"].data = formattedData
                }
                tempReportData["submissions"].totalCount = data.totalSubmissionCount || 0
                return tempReportData
            })

        }
        else {
            showAlert(data.message)
        }

    }

    catch (err) {
        console.log("Error fetching submission report:", err);
        showAlert("Trouble in connecting to the server!")
    }
    finally {
        setLoading(prev => ({
            ...prev,
            [key]: false
        }))
    }
}